import { render, staticRenderFns } from "./countSample.vue?vue&type=template&id=10c50d5c&scoped=true&"
import script from "./countSample.vue?vue&type=script&lang=js&"
export * from "./countSample.vue?vue&type=script&lang=js&"
import style0 from "./countSample.vue?vue&type=style&index=0&id=10c50d5c&prod&scoped=true&lang=less&"
import style1 from "./countSample.vue?vue&type=style&index=1&id=10c50d5c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c50d5c",
  null
  
)

export default component.exports